export const FAVORITES_CACHE_KEY = 'favorites-first-page';
export const WATCH_HISTORY_CACHE_KEY = 'history-first-page';
